"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Period;

(function (Period) {
  Period["Year"] = "Year";
  Period["Quarter"] = "Quarter";
  Period["Month"] = "Month";
  Period["Daily"] = "Daily";
  Period["D260"] = "D260";
  Period["D252"] = "D252";
})(Period = exports.Period || (exports.Period = {}));